import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_taqaved-energy/artifacts/fcw0g5in_WhatsApp%20Image%202026-06-29%20at%2011.30.38%20PM.jpeg";

// TAQAVED Logo — official brand mark
// `variant`:
//   "dark"  -> logo shown as-is (for light backgrounds)
//   "light" -> logo shown inside a soft white pill (for dark backgrounds)
export default function Logo({ variant = "dark", className = "" }) {
  const onDark = variant === "light";
  return (
    <div
      className={`inline-flex items-center ${className}`}
      data-testid="taqaved-logo"
    >
      <div
        className={
          onDark
            ? "bg-white rounded-lg px-2.5 py-1.5 shadow-sm"
            : "px-0 py-0"
        }
      >
        <img
          src={LOGO_URL}
          alt="TAQAVED — Energy with Purpose"
          className="h-10 md:h-11 w-auto object-contain block"
          draggable="false"
        />
      </div>
    </div>
  );
}
